// Shared constants + helpers for the Work Orders / Órdenes de trabajo feature.

// Return a Date's LOCAL calendar date as "YYYY-MM-DD" without applying any
// timezone shift. Using toISOString() rolls the day back during Canary summer
// time (UTC+1), so any date-string produced from a Date must go through here.
export function toLocalYmd(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

// Today's local calendar date as "YYYY-MM-DD" — safe against DST/timezone.
export function todayLocalYmd() {
  return toLocalYmd(new Date());
}

export const WO_TIPO_LABEL = {
  orden_trabajo: "Orden de trabajo",
  calificacion: "Planificación de obra",
};

export const WO_TIPO_ORDER = ["orden_trabajo", "calificacion"];

export const WO_ESTADO_LABEL = {
  pendiente: "Pendiente",
  aceptada: "Aceptada",
  en_curso: "En curso",
  completada: "Completada",
  cancelada: "Cancelada",
};

export const WO_ESTADO_STYLE = {
  pendiente:  "bg-slate-100 text-slate-700 border-slate-300",
  aceptada:   "bg-sky-100 text-sky-800 border-sky-300",
  en_curso:   "bg-amber-100 text-amber-800 border-amber-300",
  completada: "bg-emerald-100 text-emerald-800 border-emerald-300",
  cancelada:  "bg-rose-100 text-rose-700 border-rose-300",
};

export const WO_PRIORIDAD_LABEL = {
  baja: "Baja",
  media: "Media",
  alta: "Alta",
};

export const WO_PRIORIDAD_STYLE = {
  baja: "bg-slate-100 text-slate-600",
  media: "bg-sky-100 text-sky-700",
  alta: "bg-rose-100 text-rose-700",
};

export const WO_TIPO_DOT = {
  orden_trabajo: "#F5A623",   // amber — daily work orders
  calificacion:  "#0E78C2",   // blue — inspections / calificaciones
};

// Format a YYYY-MM-DD into a Spanish short label ("lun 25 ago")
export function formatFechaCorta(iso) {
  if (!iso || iso.length < 10) return iso || "";
  const d = new Date(iso + "T00:00:00");
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("es-ES", { weekday: "short", day: "numeric", month: "short" });
}

// Build the calendar cells for a given month (Mon-Sun grid).
export function buildMonthGrid(year, month) {
  // month is 0-indexed. Return an array of { date: YYYY-MM-DD, inMonth: bool }
  const first = new Date(year, month, 1);
  const firstDow = (first.getDay() + 6) % 7; // 0=Mon … 6=Sun
  const start = new Date(year, month, 1 - firstDow);
  const out = [];
  for (let i = 0; i < 42; i++) {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    out.push({
      date: toLocalYmd(d),
      inMonth: d.getMonth() === month,
      isToday: d.toDateString() === new Date().toDateString(),
      dayOfMonth: d.getDate(),
    });
  }
  return out;
}
